import dayjs from 'dayjs';

export const formatLocalDate = (value: string) => {
  if (!value) return '';
  return dayjs(value).local().format('L');
};

/** Ngày học sinh không ăn bán trú: không món trưa, không quà chiều. */
export const isNonEatingDay = (day: { dishes?: string[]; afternoons?: string[][] }) =>
  !day.dishes?.length && !(day.afternoons ?? []).flat().length;

/** Lý do MenuPlan gửi sang. Không có lý do thì chuỗi rỗng — thẻ ngày để trống. */
export const nonEatingDayLabel = (day: {
  dishes?: string[];
  afternoons?: string[][];
  noMealReason?: string | null;
}) => {
  if (!isNonEatingDay(day)) return '';
  return (day.noMealReason ?? '').trim();
};

/** Cả tuần không món và không ngày nào có lý do thì không dựng khung. */
export const isAbridgedWeekBlank = (
  days: { dishes?: string[]; afternoons?: string[][]; noMealReason?: string | null }[]
) => days.every((day) => !day.dishes?.length && !nonEatingDayLabel(day));

/** Nhãn ngày không ăn to hơn chữ món ăn một chút cho dễ thấy. */
export const nonEatingLabelFontSize = (contentFontSize: number) => `${contentFontSize + 4}px`;
